import React from "react";
import CountUp from "react-countup";
import { useNavigate } from "react-router-dom";

const Trip = () => {
    const navigate = useNavigate();
    return (
        <div >
            <div className="indicator-container">
                <div className="indicator ">

                </div>
                <div className="indicator ">

                </div>
                <div className="indicator">

                </div>
                <div className="indicator selected">

                </div>
                <div className="indicator">

                </div>
                <div className="indicator">

                </div>
            </div>

            <div style={{
                marginTop: '5vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'

            }}>

                <h1 className="large-text">Washington DC</h1>
                <div className="sim-grid">
                    <div className="left-grid">
                        <img className="vivify fadeIn delay-100" src="/assets/IMG_0923.png" alt="dad" />
                    </div>
                    <div className="right-grid">
                        <img className="vivify fadeIn delay-300" src="/assets/IMG_0943 1.png" alt="dad" />
                        <img className="vivify fadeIn delay-600" src="/assets/IMG_2383.png" alt="dad" />
                    </div>
                </div>

                <h1 className="large-text">You Went on a Massive Trip This Year</h1>
                <div className="large-button-container">
                    <button onClick={
                        () => {
                            navigate('/dad/nfl');
                        }
                    } className="large-button">
                        Let's Continue
                    </button>
                </div>
            </div>

        </div>
    );
}

export default Trip